<template>
  <b-link
    routerTag="div"
    :to="`/competitions/${competition.id}`"
    class="d-flex cursor-pointer w-100"
  >
    <b-card
      no-body
      class="p-50 d-flex cursor-pointer w-100 hover-card overflow-hidden position-relative"
    >
      <div
        class="position-absolute h-100 w-100 bg-remain-secondary d-flex left-0 justify-content-center align-items-start"
        v-if="competition.verify_status == 'CANCELED'"
        style="z-index: 2; backdrop-filter: blur(4px)"
      >
        <h4 class="bg-remain-danger w-100 rounded text-center py-75 m-50">
          Canceled
        </h4>
      </div>
      <div>
        <div
          class="d-flex justify-content-center overflow-hidden align-items-center position-relative"
          style="border-radius: 10px 10px 0 0; height: 200px"
        >
          <div
            v-if="competition.verify_status !== 'CANCELED'"
            class="d-flex w-100 align-items-stritch position-absolute top-0 left-0 text-white rounded"
            :class="`bg-remain-${remaining.status} `"
          >
            <div
              v-if="competition.verify_status !== 'READY_TO_BUY'"
              :class="`p-75 px-50 d-flex align-items-center   bg-remain-${
                competition.verify_status == 'PENDING'
                  ? 'warning'
                  : competition.verify_status == 'ACCEPTED'
                  ? 'success'
                  : competition.verify_status == 'REJECTED'
                  ? 'danger'
                  : 'warning'
              }`"
              style="border-radius: 10px 0px 19px 0px"
            >
              <small>
                {{
                  competition.verify_status == "PENDING"
                    ? "Pending"
                    : competition.verify_status == "ACCEPTED"
                    ? "Accepted"
                    : competition.verify_status == "REJECTED"
                    ? "Rejected"
                    : "Pending"
                }}
              </small>
            </div>

            <div
              class="py-75 px-1 ml-auto"
              v-if="competition.verify_status !== 'CANCELED'"
            >
              <small>
                {{ remaining.message }}
                <span v-if="(date = remaining.time)">
                  {{ date }}
                </span>
              </small>
            </div>
          </div>
          <b-img
            :src="competition.thumbnail || errorImage"
            fluid
            @error="setAltImg"
            :alt="competition.title"
            class="w-100 h-100"
          />
        </div>
      </div>
      <b-card-body class="px-1">
        <div>
          <div
            class="d-flex justify-content-between align-items-center w-100 pb-2"
          >
            <div class="d-flex align-items-center">
              <div
                class="bg-warning rounded-lg mr-50"
                style="width: 4px; height: 10px"
              ></div>
              <small class="text-white">
                {{ competition.name }}
              </small>
            </div>
            <div
              class="d-flex justify-content-end"
              v-if="userData.type !== 'user'"
            >
              <b-badge
                class="p-50"
                :variant="competition.active ? 'info' : 'danger'"
                >{{ competition.active ? "Active" : "Not active" }}</b-badge
              >
              <b-badge
                class="ml-50 pt-50"
                variant="warning"
                v-if="
                  userData.type == 'partner' &&
                  competition.award_type === 'ABSOLUTE' &&
                  competition.paid_at
                "
              >
                Paid
              </b-badge>
            </div>
          </div>
          <h4
            class="py-sm-0 py-50 mb-1"
            v-if="
              userData.type == 'admin' &&
              competition.partner &&
              competition.partner.data
            "
          >
            <span v-if="competition.partner.data.flag_url">
              <b-img
                class="rounded-circle"
                width="24"
                height="24"
                :src="competition.partner.data.flag_url || errorImage"
                @error="setAltImg"
              />
            </span>
            {{ competition.partner.data.name || "" }}
          </h4>
          <div class="d-flex justify-content-between flex-wrap">
            <div
              @click.stop
              class="w-100 d-flex align-items-center"
              v-if="competition.verify_status != 'CANCELED'"
            >
              <b-button
                v-if="userData.type === 'admin'"
                class="mr-50 mb-1 hover-warning"
                @click="$emit('showChangeStatusModal', competition)"
              >
                <feather-icon icon="RepeatIcon" size="12" />
                <span class="small"> Change status </span>
              </b-button>
              <b-button
                v-if="
                  userData.type == 'partner' &&
                  competition.award_type === 'ABSOLUTE' &&
                  !competition.paid_at
                "
                class="mr-50 mb-1 small hover-danger"
                @click="$emit('showPayModal', competition)"
              >
                <feather-icon icon="DollarSignIcon" size="12" />
                <span class="small"> Ready to pay </span>
              </b-button>
              <b-button
                v-if="userData.type != 'user' && competition.cancelable"
                class="mb-1 small hover-danger"
                @click="$emit('cancel', competition.id)"
              >
                <feather-icon icon="XIcon" size="12" />
                <span class="small"> Cancel </span>
              </b-button>
            </div>
          </div>

          <div class="d-flex flex-wrap justify-content-between">
            <div class="my-50 px-0 col-sm-6 col-12">
              <b-avatar
                size="28"
                class="mr-25"
                variant="light-info"
                v-b-tooltip.hover="'Broker'"
                rounded="circle"
              >
                <feather-icon icon="MapIcon" size="18" />
              </b-avatar>
              <span class="mr-25">Broker:</span>
              <template
                v-if="
                  hasOwnNestedProperty(competition, 'brokers.data') &&
                  competition.brokers.data.length
                "
              >
                <span
                  v-for="(broker, index) in competition.brokers.data"
                  :key="index"
                  >{{ broker.name
                  }}<span v-if="competition.brokers.data.length !== index + 1">
                    ,
                  </span></span
                >
              </template>
              <template v-else>-</template>
            </div>
            <div class="col-12 col-sm-6 d-flex flex-wrap my-50 px-0">
              <b-avatar
                size="28"
                class="mr-25"
                variant="light-info"
                v-b-tooltip.hover="'Symbol'"
                rounded="circle"
              >
                <feather-icon icon="BookmarkIcon" size="18" />
              </b-avatar>
              <p class="mr-25 mb-0">Symbol:</p>
              <div class="nowrap-white-space flex">
                <template v-if="symbols.length">
                  <div
                    class="d-flex mb-25"
                    v-for="(symbol, index) in symbols"
                    :key="index"
                  >
                    <div class="d-flex" v-if="loadSymbols">
                      <div class="d-flex">
                        <b-img
                          width="18"
                          height="18"
                          class="rounded-circle"
                          :src="errorImage"
                          @error="setAltImg"
                          :alt="symbol.name"
                        />
                      </div>
                    </div>
                    <template v-else>
                      <div
                        :class="[
                          'd-flex',
                          Object.keys(symbol.url).findIndex((key) =>
                            key.includes('base')
                          ) > -1 && 'ml-50',
                        ]"
                        v-if="symbol.url && Object.keys(symbol.url).length"
                      >
                        <template
                          v-for="(key, index) in Object.keys(symbol.url)"
                        >
                          <div
                            v-if="key.includes('logoid')"
                            class="d-flex position-relative"
                            :key="index"
                          >
                            <b-img
                              :src="convertUrl(symbol.url[key])"
                              width="18"
                              height="18"
                              class="rounded-circle ml-25"
                              @error="setAltImg"
                              :alt="symbol.name"
                              :style="[
                                key.includes('base') &&
                                  'position:absolute;right: 10px;',
                              ]"
                            />
                          </div>
                        </template>
                      </div>
                    </template>
                    <span class="ml-25">{{ symbol.name }}</span>
                    <span class="mx-25" v-if="symbols.length - 1 != index"
                      >,</span
                    >
                  </div>
                </template>
                <span v-else>-</span>
              </div>
            </div>

            <div class="my-50 px-0 col-sm-6 col-12">
              <b-avatar
                size="28"
                v-b-tooltip.hover="'Balance'"
                class="mr-25"
                variant="light-success"
                rounded="circle"
              >
                <feather-icon icon="BriefcaseIcon" size="18" />
              </b-avatar>
              <span class="mr-25">Balance:</span
              ><span class="nowrap-white-space">{{
                competition.starting_balance_value || "-"
              }}</span>
            </div>
            <div class="my-50 px-0 col-sm-6 col-12">
              <b-avatar
                v-b-tooltip.hover="'Duration'"
                size="28"
                class="mr-25"
                variant="light-danger"
                rounded="circle"
              >
                <feather-icon icon="ClockIcon" size="18" />
              </b-avatar>
              <span class="mr-25">Duration:</span
              ><span class="nowrap-white-space">{{ duration || "-" }}</span>
            </div>
            <div class="my-50 px-0 col-sm-6 col-12">
              <b-avatar
                v-b-tooltip.hover="'Duration'"
                size="28"
                class="mr-25"
                variant="light-warning"
                rounded="circle"
              >
                <feather-icon icon="DollarSignIcon" size="18" />
              </b-avatar>
              <span class="mr-25">Registration fee:</span
              ><span class="nowrap-white-space">{{
                parseFloat(competition.fee) + "$" || "-"
              }}</span>
            </div>
            <!-- <div class="my-50 px-0 col-12 d-flex align-items-center">
              <span class="text-danger mr-50 h4 mb-0 font-weight-bold"
                >${{ competition.fee }}</span
              ><small>registration fee</small>
            </div> -->
            <div
              class="my-50 px-0 col-sm-6 col-12"
              v-if="
                competition.accounts &&
                competition.accounts.data &&
                competition.accounts.data[0]
              "
            >
              <b-avatar
                size="28"
                class="mr-25"
                variant="light-info"
                v-b-tooltip.hover="'Account'"
                rounded="circle"
              >
              </b-avatar>
              <span class="mr-25">Active account:</span
              ><span class="nowrap-white-space">{{
                competition.accounts &&
                competition.accounts.data &&
                competition.accounts.data[0]
                  ? competition.accounts.data[0].user_name
                  : "-"
              }}</span>
            </div>
          </div>
        </div>
      </b-card-body>
      <div class="w-100 px-1 pb-1 d-flex justify-content-between flex-wrap">
        <b-avatar-group
          class="d-flex"
          size="34px"
          v-if="competition.participants && competition.participants.length"
        >
          <b-avatar
            v-for="(participant, index) in competition.participants"
            :key="index"
            v-b-tooltip.hover.bottom="
              participant.user.first_name + ' ' + participant.user.last_name
            "
            :src="participant.user.avatar"
            class="pull-up rounded-avatar mr-25"
            style="border: 2px solid #2c2c39 !important"
          />
          <h6
            class="align-self-center cursor-pointer ml-1 mb-0"
            v-if="competition.participant_count > 8"
          >
            {{
              competition.participant_count - competition.participants.length
            }}
          </h6>
        </b-avatar-group>
      </div>

      <b-button-group v-if="competition.verify_status != 'CANCELED'">
        <b-button
          v-if="userData.type != 'user'"
          class="px-sm-2 px-0 py-1 hover-info"
          :to="`/competitions/${competition.id}/live`"
          ><feather-icon icon="ClipboardIcon" /> Leaderboard</b-button
        >
        <b-button
          class="px-sm-2 px-0 py-1 hover-warning mx-50"
          v-if="userData.type !== 'user'"
          :to="{
            name: 'competition-wallet-overview',
            params: {
              id: competition.id,
            },
          }"
          ><feather-icon icon="BookmarkIcon" /> Wallet</b-button
        >
        <b-button
          v-if="
            userData.type != 'user' && userData.type == 'admin'
              ? true
              : userData.type == 'partner' &&
                remaining.status == 'yellow' &&
                !competition.paid_at
          "
          class="px-sm-2 px-0 py-1 hover-primary"
          :to="{
            name: 'edit-competitions',
            params: { id: competition.id },
          }"
          ><feather-icon icon="EditIcon" /> Edit</b-button
        >
      </b-button-group>
    </b-card>
  </b-link>
</template>

<script>
import {
  BCard,
  BImg,
  BCardHeader,
  BCardText,
  BCardBody,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BProgress,
  BBadge,
  VBTooltip,
  BAvatarGroup,
  BLink,
  BButtonGroup,
  BButton,
  BSkeleton,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BImg,
    BCardHeader,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BProgress,
    BBadge,
    VBTooltip,
    BAvatarGroup,
    BLink,
    BButtonGroup,
    BButton,
    BSkeleton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      participants: [],
      loading: false,
      showPayModal: false,
      date: {},
      text: "",
      symbols: [],
      remaining: {},
      loadSymbols: false,
      duration: "",
    };
  },

  async created() {
    this.remaining = this.calRemaining(this.competition);
    this.duration = this.calRemain(
      this.competition.ended_at,
      this.competition.started_at
    );
    this.loadSymbols = true;
    let promiseReq = [];
    this.competition.symbol &&
      this.competition.symbol.split(",").map((item, index) => {
        this.symbols.push({ name: item });
        promiseReq.push(this.getSymboles(item, index));
      });
    await Promise.all([...promiseReq]);
    this.loadSymbols = false;
  },
  methods: {
    convertUrl(logoId) {
      return `https://s3-symbol-logo.tradingview.com/${logoId}.svg`;
    },
    async getSymboles(symbol, index) {
      try {
        const { data } = await this.$http.get(
          `/panel/symbol-search?text=${symbol.trim()}`
        );
        this.symbols[index].url =
          data.data.symbols && data.data.symbols[0] ? data.data.symbols[0] : {};
      } catch (error) {}
    },
    convertDate(date) {
      let startedDate = {};
      startedDate.month = moment(date).format("MMM");
      startedDate.day = moment(date).format("DD");
      return startedDate;
    },
  },
};
</script>
<style lang="scss" scoped>
.meetup-header {
  margin-bottom: 2rem;

  .meetup-day {
    text-align: center;
    border-right: 1px solid grey;
    padding-right: 1.3rem;
    margin-right: 1.3rem;
  }
}
</style>
